import $ from 'jquery'
import async from 'async'
import _ from 'lodash'
import cityChoser from './cityChoser'

let _p = window.xwCommon,
    _this = {
    	title:"建档",
    	name:"createWin",
    	loadBaseNodes(vm){
	        let func = (callback,reject) => {
	          vm.$bus.emit("loading",true)
	          async.waterfall([
	            ( next ) => {
	              cityChoser.getProvinceList(vm).then((data) => next(null,data),(err) => next(err))
	            },
	            ( provList, next ) => {
	              vm.cities.list = provList //.map(( item ) => {
	              //   return $.extend({cityList:[]},item)
	              // })
	              
	              next(null)
	            },
                ( next ) => {
                    _p.getStoredApiProp("order/orderType").then((data) => {
                        //console.log(data);
                        vm.orderType = data;
                        next(null)
                    })
                    //vm.orderType = 
                },
                ( next ) => {
                    let user = _p.getStoredProp("staff/query"), 
                        depart_type_id = _p.getStoredProp("staff/currentQuery").depart_type_id,
                        data = {province_id:user.province_id, city_id:user.city_id},
                        u = _p.getApiUrl("product/search")
                    $.post(u,data,(json) => {
                        let status = parseInt(json.status)
                        if(200 !== status){
                            switch(status){
                                default: 
                                  if(_p.checkAjaxStatus(vm,json,_this.title)) break;
                                  else vm.$alert(json.msg)
                                  break;
                            }
                            return;
                        }else{
                            let gData = _.groupBy(json.data,(v) => {return v.product_tpl_id}), pData = []
                            gData = _.forEach(gData,(childrens, k) =>{
                                let tpl = childrens[0], product_id = tpl.product_tpl_id, product_name = tpl.name
                                pData.push({product_name, product_id, childrens})
                            })
                            console.log(pData)
                            vm.productSearchItem = pData
                            if(depart_type_id == 2){
                                _this.getCityList(vm, user.province_id,2)
                                _this.getDistrictList(vm,[user.province_id,user.city_id])
                            }
                            next(null)
                        }
                    }).then((data)=>{
                        if(depart_type_id == 2) vm.$set(vm.orderForm,'user_cityId',[user.province_id,user.city_id])
                    })
                }
	          ],(err) => {
                vm.$bus.emit("loading",false)
	            if(err) return reject(err)
	            else return callback()
	          })
	        }
	        return new Promise(func)
        },
        initWin(vm){
            _this.loadBaseNodes(vm).then(() => {
                vm.orderForm = _this.getEmptyForm()
                vm.showDialog = true
            })
        },
        getEmptyForm(){
            return {
                order_type:1, productId:[], car_load_type:null, 
                sex:null, birthday:null, pay_type:null, mortgage_company:null
            }
        },
        changeProductSearch(vm){
        	let u = _p.getApiUrl("product/search"),cityId = cityChoser.parseCityId(vm.orderForm.cityId),
        		business_type_id = vm.orderForm.business_type_id, pay_type_id = vm.orderForm.pay_type_id,
        		data = $.extend({business_type_id, pay_type_id},cityId)
        	if(!(cityId.city_id%1e4)) delete data.city_id
	        $.post(u,data,(json) => {
                let status = parseInt(json.status)
                if(200 !== status){
                  	switch(status){
                        default: 
                          if(_p.checkAjaxStatus(vm,json,_this.title)) break;
                          else vm.$alert(json.msg)
                          break;
                    }
                    return;
                }else{
                  	vm.productSearchItem = json.data
                  	vm.$set(vm.orderForm,"product_id","")
                }
	        })
        },
        submit(vm){
        	let func = (callback,reject) => {
        		let u = _p.getApiUrl("order/newOrder"),
        			obj = vm.orderForm,
        			data = _p.cleanProp(obj,["cityId","business_type_id","pay_type_id","user_cityId","productId"])
                if(obj.productId.length > 1){
                    data.product_id = obj.productId[1]
                }
                
        		data.birthday = _p.date("yyyy-MM-dd",data.birthday)
        		data.resident_address = cityChoser.toCityName(vm,obj.user_cityId)+data.resident_address
        		$.post(u,data,(json) => {
        			//console.log(json)
        			let status = parseInt(json.status)
	                if(200 !== status){
	                  	switch(status){
	                        default: 
	                        	//console.log("2222222222222222222222222")
		                        if(_p.checkAjaxStatus(vm,json,_this.title)) break;
		                        else reject(new Error(json.msg))
		                        break;
	                    }
	                    return;
	                }else{
	                	vm.$notify({title:_this.title,message:json.msg});
	                	callback(json.data)
	                }
        		},"json")
        	}
        	
        	return new Promise(func)
        },
        getCustomer(vm,car_num){
            let url = _p.getApiUrl("order/getSynOrderInfo")
            $.post(url,{car_num},(json) => {
                let status = parseInt(json.status)
                if(200 != status){
                  switch(status){
                    default: 
                      if(_p.checkAjaxStatus(vm,json,_this.title)) break;
                      else vm.$alert(json.msg,_this.title);
                      break;
                  }
                  return;
                }else{
                    vm.orderForm.pay_type = String(json.data.pay_type)
                    vm.orderForm.mortgage_company = json.data.mortgage_company
                    vm.orderForm.apply_purpose = json.data.apply_purpose
                    vm.orderForm.apply_price = String(json.data.apply_price)
                    vm.orderForm.car_load_type = json.data.car_load_type
                    _this.getBasicInfo(vm,json.data.order_id)
                }
            })
        },
        getBasicInfo(vm,order_id){
            let url = _p.getApiUrl("order/getCustomerInfo")
            $.post(url,{order_id},(json) => {
                var json = eval("("+json+")")
                let status = parseInt(json.status)
                if(200 != status){
                  switch(status){
                    default: 
                      if(_p.checkAjaxStatus(vm,json,_this.title)) break;
                      else vm.$alert(json.msg,_this.title);
                      break;
                  }
                  return;
                }else{
                    vm.orderForm.name=json.data.name
                    vm.orderForm.phone=json.data.phone
                    vm.orderForm.idcard=json.data.idcard
                    vm.orderForm.birthday=new Date(json.data.birthday)
                    vm.orderForm.sex=json.data.sex
                    let addr = cityChoser.parseAddr(vm, json.data["resident_address"])
                    vm.orderForm.resident_address = addr.addr
                    vm.orderForm.user_cityId = addr.cityId || []
                }
            })
        },
        rules:{
            "productId":[
                { type:'array', len:2, required: true, message: '请选择产品', trigger: 'change' }
            ],
            "order_type":[
                { type:'integer', required: true, message: '请选择业务方式', trigger: 'change' }
            ],
            "car_load_type":[
                { type:'integer', required: true, message: '请选择估价方式', trigger: 'change' }
            ],
            "pay_type":[
                { required: true, message: '请选择车辆按揭状态', trigger: 'blur' }
            ],
            "apply_price":[
                { required: true, message: '请输入申请金额', trigger: 'blur' },
                { min: 2, max: 32, message: '申请金额格式错误', trigger: 'blur' }
            ],
            "apply_purpose":[
                { required: true, message: '请输入申请用途', trigger: 'blur' },
                { min: 1, message: '申请用途至少需要1个字', trigger: 'blur' }
            ],
            "name":[
                { required: true, message: '请输入客户姓名', trigger: 'blur' },
                { min: 2, max: 32, message: '客户姓名格式错误', trigger: 'blur' }
            ],
            "phone":[
                { required: true, message: '请输入手机号码', trigger: 'blur' },
                { min: 7, max: 13, message: '手机号码格式错误', trigger: 'blur' },
                { validator: _p.validator.phone, message: '手机号码格式错误', trigger: 'blur' }
            ],
            "car_num":[
                { required: true, message: '请输入车牌号', trigger: 'blur' },
                { validator: _p.validator.carNum, message: '车牌号格式错误(不能存在空格符)', trigger: 'blur' }
            ],
            "car_price":[
                { required: true, message: '请输入购车价'},
                //{ type:'number',message:'购车价为数字金额'},
                { validator: _p.validator.carPrice, message: '购车价格必须为数字'}
            ],
            "is_check_car":[
                //{ required: true},
            ],
            "idcard":[
                { required: true, message: '请输入身份证号', trigger: 'blur' },
                { len: 18, message: '身份证号格式错误', trigger: 'blur' },
                { validator: _p.validator.idcard, message: '无效的身份证号', trigger: 'blur'}
            ],
            "birthday":[
                { type:'date', required: true, message: '请选择出生年月', trigger: 'change' }
            ],
            "sex":[
                { type:'integer', required: true, message: '请选择性别', trigger: 'change' }
            ],
            "resident_address":[
                { required: true, message: '请输入户口所在地', trigger: 'blur' },
                { min: 6, message: '户口所在地格式错误', trigger: 'blur' }
            ]

        },
      	getCityList:cityChoser.getCityList,
      	getDistrictList:cityChoser.getDistrictList
    }
export default _this


// WEBPACK FOOTER //
// ./src/lib/common/createWin.js